/**
 * @generated SignedSource<<a178f7083aa61251657afb0894295b93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteApplianceInput = {
  applianceId: string;
};
export type ApplianceOperations_deleteAppliance_Mutation$variables = {
  input: DeleteApplianceInput;
};
export type ApplianceOperations_deleteAppliance_Mutation$data = {
  readonly deleteAppliance: {
    readonly appliance: {
      readonly id: string;
    };
  } | null;
};
export type ApplianceOperations_deleteAppliance_Mutation = {
  response: ApplianceOperations_deleteAppliance_Mutation$data;
  variables: ApplianceOperations_deleteAppliance_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteAppliancePayload",
    "kind": "LinkedField",
    "name": "deleteAppliance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "appliance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApplianceOperations_deleteAppliance_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApplianceOperations_deleteAppliance_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa38bfe9f2f1016de69aa6367e151264",
    "id": null,
    "metadata": {},
    "name": "ApplianceOperations_deleteAppliance_Mutation",
    "operationKind": "mutation",
    "text": "mutation ApplianceOperations_deleteAppliance_Mutation(\n  $input: DeleteApplianceInput!\n) {\n  deleteAppliance(input: $input) {\n    appliance {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d0c167bff7a3483da115e48cbb2b74b";

export default node;
